// extracted by mini-css-extract-plugin
export default {"container":"EventStatus_container__S3gYs","body":"EventStatus_body__tKa1g"};